import React from 'react';

import RegistrationForm from '@components/forms/registration';

import useRegistration from './hooks';

function Registration({ validatedEmail }: { validatedEmail?: string }) {
	const { initialValues, onSubmit } = useRegistration({ validatedEmail });

	return <RegistrationForm initialValues={initialValues} onSubmit={onSubmit} emailDisabled={Boolean(validatedEmail)} />;
}

export default Registration;
